/**
 * Panamanian balboa.
 */
export var PAB = {
  code: 'PAB',
  base: 10,
  exponent: 2
};